// src/sections/footer/DesktopFooter.jsx
import "./DesktopFooter.css";
import { useLang } from "../../../i18n/LangContext";

export default function DesktopFooter({
  id = "footer",
  logoSrc,
  logoAlt = "Givvy logo",
  globeSrc,
  globeOverlaySrc,
  globeAlt = "Global network illustration",
  socialLinks = ["#", "#", "#", "#", "#", "#"],
}) {
  const { t } = useLang();
  const ft = t.footer;
  if (!ft) return null;

  const columns = [
    ft.menuTitle && { title: ft.menuTitle, items: ft.menuItems || [] },
    ft.infoTitle && { title: ft.infoTitle, items: ft.infoItems || [] },
    ft.extraTitle && { title: ft.extraTitle, items: ft.extraItems || [] },
    ft.extraTitle2 && { title: ft.extraTitle2, items: ft.extraItems2 || [] },
    ft.extraTitle3 && { title: ft.extraTitle3, items: ft.extraItems3 || [] },
  ].filter(Boolean);

  return (
    <footer id={id} className="ft-root ft-desktop" aria-label="Site footer">
      <div className="ft-top">
        <div className="ft-wrap ft-top-inner">
          <div className="ft-brand">
            {logoSrc ? (
              <img src={logoSrc} alt={logoAlt} className="ft-logo-img" />
            ) : (
              <span className="ft-logo-text">{ft.brandName}</span>
            )}
            <p className="ft-brand-text">{ft.brandText}</p>
          </div>

          <div className="ft-cols">
            {columns.map((col) => (
              <div key={col.title} className="ft-col">
                <h3 className="ft-col-title">{col.title}</h3>
                <ul className="ft-list">
                  {col.items.map((item) => {
                    const label = typeof item === "string" ? item : item.label;
                    const href = typeof item === "string" ? "#" : item.href || "#";
                    return (
                      <li key={label} className="ft-list-item">
                        <a href={href} className="ft-link">{label}</a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>

          <div className="ft-hero">
            <div className="ft-hero-inner">
              {globeSrc && (
                <img src={globeSrc} alt={globeAlt} className="ft-globe-img" />
              )}
              {globeOverlaySrc && (
                <img
                  src={globeOverlaySrc}
                  alt=""
                  aria-hidden="true"
                  className="ft-globe-overlay"
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="ft-bottom">
        <div className="ft-wrap ft-bottom-inner">
          <div className="ft-copy">{ft.copyright}</div>
        </div>
      </div>
    </footer>
  );
}
